// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3_YRg","legacyBtn":"MutateMid_legacyBtn__1BY13"};